import Link from "next/link";
import PopularGames from "../components/PopularGames";
export default function HomeDis(props) {
  return (
    <div className="dis-container">
      
        <div className="thumb-dis">
        <div className="dis">
            <div className="contant para description"dangerouslySetInnerHTML={{__html:props.dis}}></div>
          </div>
      </div>
    </div>
  );
}
